import ObjectTools from 'utils/objects/objectTools'
const generalConfig = {
  chart: {
    type: 'line',
    style: {
      fontFamily: '\'Montserrat\', Helvetica, Arial, sans-serif'
    },
    marginBottom: 60,
    backgroundColor: 'rgba(0,0,0,0)'
  },
  credits: {
    enabled: true,
    text: '',
    href: 'https://www.orkestra.deusto.es',
    position: {
      y: -5
    },
    style: {
      fontSize: '12px'
    }
  },
  exporting: {
    sourceWidth: 800,
    sourceHeight: 500,
    buttons: {
      contextButton: {
        enabled: false
      }
    }
  },
  title: {
    text: ''
  },

  subtitle: {
    text: ''
  },
  xAxis: {
    allowDecimals: false
  },
  yAxis: {
    title: {
      text: ''
    }
  },
  tooltip: {
    valueSuffix: ''
  },

  legend: {
    enabled: true,
    layout: 'horizontal',
    align: 'right',
    verticalAlign: 'top',
    y: -30,
    itemStyle: {
      fontWeight: 'normal'
    },
    symbolWidth: 30
  },
  plotOptions: {
    series: {
      marker: {
        enabled: false,
        symbol: 'circle'
      },
      label: {
        enabled: false
      }
    }
  },
  series: []
}

let selectedRegionConfig = ObjectTools.copyObject(generalConfig)
let allRegionsConfig = ObjectTools.copyObject(generalConfig)
let referenceRegionsConfig = ObjectTools.copyObject(generalConfig)
let sameCountryRegionsConfig = ObjectTools.copyObject(generalConfig)
let otherRegionsConfig = ObjectTools.copyObject(generalConfig)

const chartLinesConfig = {
  selectedRegionConfig,
  allRegionsConfig,
  referenceRegionsConfig,
  sameCountryRegionsConfig,
  otherRegionsConfig
}

export default chartLinesConfig



// WEBPACK FOOTER //
// ./src/modules/Charts/Lines/LinesChart/LinesChartConfig.js